<template>
    <div data-component="AmsPriceIndicatorModalRecommendation">
        <div
            class="rounded-10 text-h4"
            :class="{
                'bg-color-rating-darkgreen-25': priceClass === PriceClass.VeryGoodPrice,
                'bg-color-rating-mediumgreen-25': priceClass === PriceClass.GoodPrice,
                'bg-color-rating-lightgreen-25': priceClass === PriceClass.FairPrice,
                'bg-color-rating-lightorange-25': priceClass === PriceClass.IncreasedPrice,
                'bg-color-rating-mediumorange-25': priceClass === PriceClass.HighPrice,
                'p-0': priceClass === PriceClass.NotSpecified,
                'p-24': priceClass !== PriceClass.NotSpecified,
            }"
        >
            <p class="mb-8 font-bold">
                {{ headline }}
            </p>

            <p>{{ recommendationText }}</p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue'
import { PriceClass } from '../../../services/amsSearch/amsSearch.interface'
import { RecommendationText } from './AmsPriceIndicatorModal.interface'
import { determinePriceTextBy } from '../AmsPriceIndicatorHelpers'

const props = defineProps({
    priceClass: { type: Number as PropType<PriceClass>, required: true },
    hasRating: Boolean,
})

const headline = computed(() => determineHeadline())
const recommendationText = mapRecommendationText()

function determineHeadline() {
    if (props.priceClass === PriceClass.NotSpecified) {
        return 'Berechnung nicht möglich'
    }

    return `Unsere Empfehlung - ${determinePriceTextBy(props.priceClass)}`
}

function mapRecommendationText() {
    switch (props.priceClass) {
        case PriceClass.HighPrice:
            return RecommendationText.HighPrice
        case PriceClass.IncreasedPrice:
            return RecommendationText.IncreasedPrice
        case PriceClass.FairPrice:
            return RecommendationText.FairPrice
        case PriceClass.GoodPrice:
            return RecommendationText.GoodPrice
        case PriceClass.VeryGoodPrice:
            return RecommendationText.VeryGoodPrice
        case PriceClass.NotSpecified:
            return RecommendationText.NotSpecified
        default:
            return ''
    }
}
</script>
